import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';
import { ISupplierModel } from '../types';

interface IProps {
    supplierExternalId: string;
}
export const useGetSupplierById = ({ supplierExternalId }: IProps) => {
  const { customerId } = useStore(state => state.user);
  const { accountExternalId } = useStore(state => state.getPersonalAccount());
  return useQuery(
    'useGetSupplierById',
    async () => {
      const res = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/supplier/${supplierExternalId}`);
      return res.data.supplier as ISupplierModel;
    },
    {
      enabled: false,
      cacheTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
    },

  );
};
